"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunk5PPYT3PBcjs = require('./chunk-5PPYT3PB.cjs');


var _chunkW7K7GB4Dcjs = require('./chunk-W7K7GB4D.cjs');


var _chunkFNPPNAGRcjs = require('./chunk-FNPPNAGR.cjs');


var _chunk7ZPN562Ocjs = require('./chunk-7ZPN562O.cjs');


var _chunk7Y3FNKTFcjs = require('./chunk-7Y3FNKTF.cjs');

// src/contracts/dex/v2_1/index.ts
var DEX = {
  Router: _chunkW7K7GB4Dcjs.RouterV2_1,
  Pool: _chunk5PPYT3PBcjs.PoolV2_1,
  LpAccount: _chunk7ZPN562Ocjs.LpAccountV2_1,
  Vault: _chunkFNPPNAGRcjs.VaultV2_1,
  pTON: _chunk7Y3FNKTFcjs.PtonV2_1
};



exports.DEX = DEX;
//# sourceMappingURL=chunk-I7EIKUJS.cjs.map